import { render, staticRenderFns } from "./ModalCreateProject.vue?vue&type=template&id=402f64b4&"
import script from "./ModalCreateProject.vue?vue&type=script&lang=js&"
export * from "./ModalCreateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports